<!--
  -  TTTech nerve-management-system
  -  Copyright(c) 2021. TTTech Industrial Automation AG.
  -
  -  ALL RIGHTS RESERVED.
  -
  -  Usage of this software, including source code, netlists, documentation,
  -  is subject to restrictions and conditions of the applicable license
  -  agreement with TTTech Industrial Automation AG or its affiliates.
  -
  -  All trademarks used are the property of their respective owners.
  -
  -  TTTech Industrial Automation AG and its affiliates do not assume any liability
  -  arising out of the application or use of any product described or shown
  -  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
  -  make changes, at any time, in order to improve reliability, function or
  -  design.
  -
  -  Contact Information:
  -  support@tttech-industrial.com
  -
  -  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
  -
  -->

<template>
  <v-snackbar
    v-if="utilsStore"
    id="iiotApiToastSnackbar"
    v-model="dialogState"
    :timeout="-1"
    location="top right"
    :color="toastParams.color"
    :close-on-back="false"
    data-cy="iiotApiToastSnackbar"
    class="ma-0 pa-2"
  >
    {{ toastText }}
    <template #actions>
      <v-btn
        v-if="toastParams.showClose"
        id="iiotApiToastCloseBtn"
        data-cy="iiotApiToastCloseBtn"
        icon
        autofocus
        @click="closeToast()"
      >
        <v-icon icon="mdi-close" />
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import useUtilsStore from '@/store/modules/pinia/utils/_api_request_handler';

const { t, te } = useI18n();

/** Stores */
const utilsStore = useUtilsStore();

/** Computed */
const dialogState = computed({
  get: () => utilsStore.toast,
  set: () => {},
});

const toastParams = computed({
  get: () => utilsStore.toastParams,
  set: () => {},
});

const toastText = computed(() => {
  const params = toastParams.value;
  // Additional check for space is workaround for already translated texts
  // this will not work for single words, but already translated texts shall not
  // be passed here anyway
  if (params.text.indexOf(' ') !== -1) {
    // Since it contains space, it may not be a key, so it is already translated.
    return params.text;
  }
  if (!te(params.text)) {
    return t('errorMessages.nerve_unknown_err');
  }
  return params.textParameters ? t(params.text, { textParams: params.textParameters }) : t(params.text);
});

/** Methods */
const closeToast = () => {
  utilsStore.closeToast();
};
</script>

<style lang="scss">
.v-snack__content {
  overflow-wrap: anywhere !important;
}
</style>
